import "../styles/Modal.css";

function Modal({ isOpen, onClose, children, titulo }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h4>{titulo}</h4>
          <button className="close-btn" onClick={onClose}>✖</button>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
